module.exports = __webpack_public_path__ + "js/0-legacy.38d2a756.worker.js"